import { render, staticRenderFns } from "./VuesticMultiSelect.vue?vue&type=template&id=078e9dd0"
import script from "./VuesticMultiSelect.vue?vue&type=script&lang=js"
export * from "./VuesticMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./VuesticMultiSelect.vue?vue&type=style&index=0&id=078e9dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue
// module id = 1xaq
// module chunks = 41